export const HEAR_ABOUT_US_OPTIONS = [
  "Google Search",
  "AI Assistant (ChatGPT, Claude, Gemini, etc.)",
  "Social Media",
  "YouTube",
  "LinkedIn",
  "X (Twitter)",
  "Instagram",
  "Facebook",
  "TikTok",
  "Reddit",
  "Friend or Colleague",
  "Referral",
  "Online Advertisement",
  "Blog / Article",
  "Podcast",
  "Event / Conference",
  "Partner / Affiliate",
  "Existing Customer",
  "Other",
];
